var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQmeePersonCompact = function SvgQmeePersonCompact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 34 34"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#fff",
    stroke: "#2BD675",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD675",
    d: "M18.889 30.223v-2.1c0-.762-.315-1.504-.892-2.06a3.2 3.2 0 0 0-2.215-.877H8.143c-.84 0-1.634.32-2.213.878a1.26 1.26 0 0 1-1.747-1.816 5.72 5.72 0 0 1 3.96-1.581h7.64c1.476 0 2.9.564 3.96 1.581a5.38 5.38 0 0 1 1.664 3.875v2.1a1.26 1.26 0 1 1-2.518 0M15.111 15.74a3.148 3.148 0 1 0-6.296 0 3.148 3.148 0 0 0 6.296 0m2.519 0a5.667 5.667 0 1 1-11.334 0 5.667 5.667 0 0 1 11.334 0M25.602 16.693a1.26 1.26 0 1 1 1.685 1.872l-4.197 3.778a1.26 1.26 0 0 1-1.685 0l-2.1-1.889a1.26 1.26 0 0 1 1.586-1.953l.1.081 1.255 1.13z"
  })));
};
export default SvgQmeePersonCompact;